// material-ui

import flatbedOpenTrailer from '../../../assets/images/Trailer/flatbed-open-trailer.svg';
/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoDark from 'assets/images/logo-dark.svg';
 * import logo from 'assets/images/logo.svg';
 *
 */

// ==============================|| LOGO SVG ||============================== //

const FlatbedOpenTrailer = () => {
    

    return (
        /**
         * if you want to use image instead of svg uncomment following, and comment out <svg> element.
         *
         * <img src={logo} alt="Berry" width="100" />
         *
         */
         <img src={flatbedOpenTrailer} alt="FlatbedOpenTrailer" height={20}  />
    );
};

export default FlatbedOpenTrailer;